import React, { useState, memo } from "react";
import PropTypes from "prop-types";

export const RenderRouteEditable = memo(({
  value: initialValue,
  row,
  column,
  onCellInputBlur,
}) => {
  const [value, setValue] = useState(initialValue);
  const { index } = row;
  const { id } = column;
  return (
    <input
      style={{
        backgroundColor: "#fafafa",
        border: 0,
        padding: 5,
        width: 90,
      }}
      value={value}
      onChange={(e) => setValue(e.currentTarget.value)}
      onBlur={() => onCellInputBlur(initialValue, index, id)}
    />
  );
});

RenderRouteEditable.displayName = "RenderRouteEditable";

RenderRouteEditable.propTypes = {
  value: PropTypes.string,
  row: PropTypes.shape({
    index: PropTypes.number.isRequired,
  }).isRequired,
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onCellInputBlur: PropTypes.func.isRequired,
};
